import { ArrowLeft, Smartphone, Mail } from 'lucide-react';
import { OptionCard } from './OptionCard';

interface ChangePasswordMethodScreenProps {
  onBack: () => void;
  onSelectInApp: () => void;
  onSelectEmail: () => void;
}

export const ChangePasswordMethodScreen = ({
  onBack,
  onSelectInApp,
  onSelectEmail,
}: ChangePasswordMethodScreenProps) => {
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Cambiar contraseña</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <div className="mb-2">
          <p className="text-sm text-[#6B7280]">
            Elige cómo quieres cambiar tu contraseña
          </p>
        </div>

        <OptionCard
          icon={Smartphone}
          title="Cambiar en la app"
          subtitle="Verifica tu identidad y actualiza tu contraseña aquí"
          onClick={onSelectInApp}
        />

        <OptionCard
          icon={Mail}
          title="Cambiar por correo"
          subtitle="Te enviaremos un enlace de restablecimiento"
          onClick={onSelectEmail}
        />
      </div>
    </div>
  );
};
